import type {SWRConfiguration} from 'swr'
import useSWR from 'swr'

import {getList} from '../api/listApi'
import {List} from '../types'

export default function useList(id: List['id'], options?: SWRConfiguration) {
  return useSWR<List, Error>(['list', id], () => getList(id), options)
}
